import { MainLayout } from './pages/MainLayout';
import { Button } from '@/components/ui/button';
import { LuRefreshCw, LuTriangleAlert } from 'react-icons/lu';

interface AppErrorProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}

export const AppError = ({ error, resetErrorBoundary }: AppErrorProps) => {
  const handleRefresh = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    } else {
      window.location.reload();
    }
  };

  // Check if this is a Dinero.js money-related error
  const isMoneyError =
    error?.message?.includes('You must provide an integer') ||
    error?.stack?.includes('dinero') ||
    error?.stack?.includes('MoneyFromCents');

  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
        <div className="flex flex-col items-center text-center max-w-md">
          <LuTriangleAlert className="w-16 h-16 text-orange-500 mb-4" />

          <h2 className="text-2xl font-bold text-gray-900 mb-2">Something went wrong</h2>

          <p className="text-gray-600 mb-6">
            {isMoneyError
              ? 'We encountered an issue with financial calculations. This has been logged and our team will investigate.'
              : 'An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.'}
          </p>

          {process.env.NODE_ENV === 'development' && error && (
            <details className="mb-6 p-4 bg-gray-100 rounded-md text-left text-sm max-w-full overflow-auto">
              <summary className="cursor-pointer font-medium text-red-600 mb-2">
                Error Details (Development)
              </summary>
              <pre className="whitespace-pre-wrap text-red-700">
                {error.message}
                {error.stack && `\n\nStack trace:\n${error.stack}`}
              </pre>
            </details>
          )}

          <Button onClick={handleRefresh} className="flex items-center gap-2">
            <LuRefreshCw className="w-4 h-4" />
            Try Again
          </Button>
        </div>
      </div>
    </MainLayout>
  );
};
